export default "__VITE_ASSET__Ys6TvMf4__"